import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow}) {

    return (
        <MortgageForm inExtWindow={inExtWindow} questions={[
            {
                name: 'addressCurrent',
                label: 'Current Address',
                answer: {
                    type: 'textarea',
                    asArray: false,
                },
                target: `applicant${section.applicant}.personal.addressCurrent`
            },
            {
                name: 'proofOfAddressRequired',
                label: 'Own Proof of Address Required',
                answer: {
                    type: 'select',
                    choices: [
                        {
                            value: true,
                            text: 'Yes'
                        }, {
                            value: false,
                            text: 'No'
                        }
                    ]
                },
                target: `applicant${section.applicant}.personal.proofOfAddressRequired`
            }
        ]}/>
    );
}

export default ApplicationForm;